module.exports = __webpack_public_path__ + "media/item_reveal3_rare.a80ee8b1.wav";